import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { destroyGame } from '../../../api/game-mode';
import { abortGame } from '../../../api/game-mode/game';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { SAVE_GAME_RESULT_MODAL_COUNT_KEY } from '../../../app.config.vars/stored';
const ConfirmEndGameSession = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const handleConfirm = async () => {
        dispatch(setIsModalOpen(false));
        dispatch(setModalContent(null));
        // escape hatch for a stuck game: remove the server session when possible, always clear locally
        const result = await abortGame();
        if (result !== 'aborted') {
            sessionStorage.removeItem(SAVE_GAME_RESULT_MODAL_COUNT_KEY);
            await destroyGame();
        }
        navigate(APP_ROUTES.rallies);
    };
    const handleCancel = () => {
        dispatch(setIsModalOpen(false));
        dispatch(setModalContent(null));
    };
    return (_jsxs("div", { className: 'modal-content confirm-action', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('confirm_end_game_session'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.cancel'), onClick: handleCancel }), _jsx(Button, { variant: 'outlined', label: t('button.end_game_session'), onClick: handleConfirm })] }) })] }));
};
export default ConfirmEndGameSession;
